export default __webpack_public_path__ + "static/san_banner-3267b7eaf16e12a3bcb7d9c708c68813.webp";